import React ,{Component} from 'react';

export default class extends Component{
    render(){
        return(
         <footer>
     {/* Footer  */}
	<section id="footer">
		<div className="container">
			<div className="row text-center text-xs-center text-sm-left text-md-left">
				<div className="col-xs-12 col-sm-4 col-md-4">
					<h5>Quick links</h5>
					<ul className="list-unstyled quick-links">
						<li><a href="#n"><i className="fa fa-angle-double-right"></i>Home</a></li>
						<li><a href="#n"><i className="fa fa-angle-double-right"></i>About</a></li>
						<li><a href="#n"><i className="fa fa-angle-double-right"></i>FAQ</a></li>
						<li><a href="#n"><i className="fa fa-angle-double-right"></i>Get Started</a></li>
						<li><a href="#n"><i className="fa fa-angle-double-right"></i>Videos</a></li>
					</ul>
				</div>
				<div className="col-xs-12 col-sm-4 col-md-4">
					<h5>Quick links</h5>
					<ul className="list-unstyled quick-links">
						<li><a href="#n"><i className="fa fa-angle-double-right"></i>Home</a></li>
						<li><a href="#n"><i className="fa fa-angle-double-right"></i>About</a></li>
						<li><a href="#n"><i className="fa fa-angle-double-right"></i>FAQ</a></li>
						<li><a href="#n"><i className="fa fa-angle-double-right"></i>Get Started</a></li>
						<li><a href="#n"><i className="fa fa-angle-double-right"></i>Videos</a></li>
					</ul>
				</div>
				<div className="col-xs-12 col-sm-4 col-md-4">
					<h5>Quick links</h5>
					<ul className="list-unstyled quick-links">
						<li><a href="#n"><i className="fa fa-angle-double-right"></i>Home</a></li>
						<li><a href="#n"><i className="fa fa-angle-double-right"></i>About</a></li>
						<li><a href="#n"><i className="fa fa-angle-double-right"></i>FAQ</a></li>
						<li><a href="#n"><i className="fa fa-angle-double-right"></i>Get Started</a></li>
						<li><a href="#n" title="Design and developed by"><i className="fa fa-angle-double-right"></i>Imprint</a></li>
					</ul>
				</div>
			</div>
			<div className="row">
				<div className="col-xs-12 col-sm-12 col-md-12 mt-2 mt-sm-5">
					<ul className="list-unstyled list-inline social text-center">
						<li className="list-inline-item"><a href="#n"><i className="fa fa-facebook"></i></a></li>
						<li className="list-inline-item"><a href="#n"><i className="fa fa-twitter"></i></a></li>
						<li className="list-inline-item"><a href="#n"><i className="fa fa-instagram"></i></a></li>
						<li className="list-inline-item"><a href="#n"><i className="fa fa-google-plus"></i></a></li>
						<li className="list-inline-item"><a href="#n" target="_blank"><i className="fa fa-envelope"></i></a></li>
					</ul>
				</div>
			
			</div>	
			<div className="row">
				<div className="col-xs-12 col-sm-12 col-md-12 mt-2 mt-sm-2 text-center text-white">
					<p><a href="#n">Flamigo</a> is a Registered</p>
					<p className="h6">&copy; All right Reversed.<a className="text-green ml-2" href="#n" target="_blank">Flamigo</a></p>
				</div>
				
			</div>	
		</div>
	</section>
	{/* Footer End*/}
     </footer>
        )
    }
}